import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, History, X, ImageOff } from 'lucide-react';
import { searchAPI } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';
import { getRecentlyViewed, clearRecentlyViewed } from '../../utils/recentlyViewed';

const fmtPrice = (l) => (l.price_type === 'free' ? 'Gratuit' : l.price ? `${Number(l.price).toLocaleString('fr-FR')} €` : '');

export const SearchSuggestions = ({ onPickTerm, onNavigate, compact = false }) => {
  const { t } = useLanguage();
  const [trending, setTrending] = useState([]);
  const [recent, setRecent] = useState(() => getRecentlyViewed());

  useEffect(() => {
    searchAPI.trending(compact ? 6 : 10).then((d) => setTrending(d.terms || [])).catch(() => setTrending([]));
  }, [compact]);

  if (trending.length === 0 && recent.length === 0) return null;

  return (
    <div className={compact ? 'p-3 space-y-3' : 'space-y-5'} data-testid="search-suggestions">
      {trending.length > 0 && (
        <section>
          <p className="text-[11px] uppercase tracking-wide font-semibold text-gray-400 flex items-center gap-1 mb-2">
            <TrendingUp className="h-3 w-3" /> {t('search.trending')}
          </p>
          <div className="flex flex-wrap gap-1.5" data-testid="trending-terms">
            {trending.map((it) => (
              <button key={it.term} type="button" onClick={() => onPickTerm(it.term)}
                      className="px-3 py-1.5 rounded-full bg-gray-100 hover:bg-emerald-50 hover:text-emerald-700 text-xs sm:text-sm text-gray-700 transition-colors"
                      data-testid={`trending-term-${it.term.replace(/\s+/g, '-').toLowerCase()}`}>
                {it.term}
              </button>
            ))}
          </div>
        </section>
      )}
      {recent.length > 0 && (
        <section>
          <div className="flex items-center justify-between mb-2">
            <p className="text-[11px] uppercase tracking-wide font-semibold text-gray-400 flex items-center gap-1">
              <History className="h-3 w-3" /> {t('search.recentlyViewed')}
            </p>
            <button type="button" onClick={() => { clearRecentlyViewed(); setRecent([]); }} className="text-[11px] text-gray-400 hover:text-gray-700 flex items-center gap-0.5" data-testid="clear-recent-btn">
              <X className="h-3 w-3" /> {t('search.clearRecent')}
            </button>
          </div>
          <div className="flex gap-2 overflow-x-auto scrollbar-hide -mx-1 px-1 pb-1" data-testid="recent-listings">
            {recent.map((l) => (
              <Link key={l.id} to={l.path} onClick={onNavigate} className={`shrink-0 ${compact ? 'w-24' : 'w-28 sm:w-32'} group`} data-testid={`recent-listing-${l.id}`}>
                <div className={`${compact ? 'h-20' : 'h-24 sm:h-28'} rounded-xl bg-gray-100 overflow-hidden flex items-center justify-center`}>
                  {l.image ? <img src={l.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform" loading="lazy" /> : <ImageOff className="h-5 w-5 text-gray-300" />}
                </div>
                <p className="text-xs font-semibold text-gray-900 mt-1 truncate">{fmtPrice(l)}</p>
                <p className="text-[11px] text-gray-500 truncate">{l.title}</p>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default SearchSuggestions;
